import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import { CapitalizeFirstLetter } from '@cdab/headless-components'
import { AuditItemList } from '@cdab/scania/qpr/components/molecules'

import { TdsIcon } from '@scania/tegel-react'
import {
  BottomSticky,
  Content,
  Dropshadow,
  IconButton,
  Navigation,
  StyledLink,
  SummaryLinkItem,
  SummaryLinkItemCenter,
  SummaryLinkItemLeft,
  SummaryLinkItemRight,
  VariableProvider
} from './audit-bottom-navigation.styles'
import type { AuditBottomNavigationProps } from './audit-bottom-navigation.types'

/**
 * If you want to hide a button, omit the callback function.
 */
export const AuditBottomNavigation = observer(
  ({
    audit,
    onItemClick,
    onLeftClick,
    onToggleMenu,
    isOpen,
    onViewPledgeClick,
    onRightClick,
    currentOpenItems = [],
    currentSelectedItem,
    onScoreChange
  }: AuditBottomNavigationProps) => {
    const { t } = useTranslation('audit')
    function toggleMenu() {
      if (onToggleMenu) {
        onToggleMenu(!isOpen)
      }
    }

    return (
      <VariableProvider>
        <Dropshadow onClick={toggleMenu} isOpen={isOpen} />
        <BottomSticky isOpen={isOpen}>
          <StyledLink to='../summary'>
            <SummaryLinkItem>
              <SummaryLinkItemLeft />
              <SummaryLinkItemCenter>
                <CapitalizeFirstLetter>
                  {t('audit-summary')}
                </CapitalizeFirstLetter>
              </SummaryLinkItemCenter>
              <SummaryLinkItemRight>
                <TdsIcon name='chevron_right' size='20px' />
              </SummaryLinkItemRight>
            </SummaryLinkItem>
          </StyledLink>
          <Content>
            <AuditItemList
              showOpenPledgeButton
              currentSelectedItem={currentSelectedItem}
              onItemClick={onItemClick}
              audit={audit}
              currentOpenItems={currentOpenItems}
              onScoreChange={onScoreChange}
              onViewPledgeClick={onViewPledgeClick}
              isBottomNavigationList={true}
            />
          </Content>
        </BottomSticky>
        <Navigation>
          <div>
            {onLeftClick && (
              <IconButton onClick={onLeftClick}>
                <TdsIcon name='chevron_left' size='md' />
              </IconButton>
            )}
          </div>

          <div>
            <IconButton onClick={toggleMenu}>
              {isOpen ? (
                <TdsIcon name='cross' size='md' />
              ) : (
                <TdsIcon name='arrow_up' size='md' />
              )}
            </IconButton>
          </div>

          <div>
            {onRightClick && (
              <IconButton onClick={onRightClick}>
                <TdsIcon name='chevron_right' size='sm' />
              </IconButton>
            )}
          </div>
        </Navigation>
      </VariableProvider>
    )
  }
)
